import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import RequestAccess from "@/pages/RequestAccess";

// Employer-only access: Hero signups now join the employer waitlist.
export const Route = createFileRoute("/hero-home-signup")({
  head: () => seoHead("/hero-home-signup"),
  component: () => <RequestAccess source="hero-home-signup" hero />,
});
